import http from '../httpClient.js';
import { getTokenString } from '../tokenService';

const tokenWithCompany = getTokenString()

const baseParams = {
    section: 'tickets',
    token: tokenWithCompany.split('&')[0],
    companyId: tokenWithCompany.split('&')[1]
}

export const addTicketForTesting = (id, obj) => {
    return http.post(
        '/', obj, {
            params: {
                ...baseParams,
                action: 'addTicketForTesting',
                ticketId: id,
            }
        }
    )
}

export const addTicketForHelp = (id, obj) => {
    return http.post(
        '/', obj, {
            params: {
                ...baseParams,
                action: 'helpByTicket',
                ticketId: id,
            }
        }
    )
}